import React, { useContext } from 'react';
import { Route, Switch } from 'react-router';
import { completedRoutes } from '../../common/constants';
import PlacesGrid from '../admin/PlacesGrid/PlacesGrid';
import AppHeader from '../AppHeader/AppHeader';
import Rules from '../common/Rules/Rules';
import ForCompanies from '../common/ForCompanies/ForCompanies';
import { Container, Hidden } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import DesktopSideBar from '../AppHeader/DesktopSideBar/DesktopSideBar';
import IsMobileContext from '../../common/IsMobileContext';
import AdminPayment from '../admin/AdminPayment/AdminPayment';

const ContentSwitch = (props) => {
  const { desktopOption } = props;

  return (
    <Switch>
      <Route path={completedRoutes.adminPayment()}>
        <AdminPayment />
      </Route>
      <Route path={completedRoutes.adminRules}>
        <Rules />
      </Route>
      <Route path={completedRoutes.adminForCompanies}>
        <ForCompanies />
      </Route>
      {desktopOption &&
      <Route>
        <PlacesGrid />
      </Route>}
    </Switch>
  );
};

function AdminPage() {
  const isMobileDesign = useContext(IsMobileContext);

  return (
    <>
      <AppHeader admin />
      <Hidden only={['xs', 'sm']}>
        <Container>
          <Grid container direction="row">
            <Grid item md={2} lg={2}>
              <DesktopSideBar admin />
            </Grid>
            <Grid item md={10} lg={10}>
              <ContentSwitch desktopOption={!isMobileDesign} />
            </Grid>
          </Grid>
        </Container>
      </Hidden>
      <Hidden mdUp>
        <Container>
          <PlacesGrid />
        </Container>
      </Hidden>
      <Hidden mdUp>
        <ContentSwitch />
      </Hidden>
    </>
  );
}

export default AdminPage;
